import React from "react"
import PropTypes from "prop-types"
import theme from "styles/theme"
import Link from "components/Link"

const LINK_LIST_TYPES = ["PDF", "XLS", "PPT", "DOC", "WEB"]

const LinkList = ({ links, className }) => (
  <div className={className}>
    {links.map((link, index) => (
      <ListItem
        key={index}
        title={link.title}
        href={link.href}
        type={link.linkType}
      />
    ))}
  </div>
)

export default LinkList

const ListItem = ({ title, href, type }) => (
  <Link
    href={href}
    target="_blank"
    css={{
      background: ["#EFEFEF", `${theme.lightGray}4A`],
      border: `1px solid ${theme.softGray}`,
      padding: 17,
      marginTop: 9,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      color: theme.textGray,
      transitionProperty: "transform, border-color, color, background-color",
      transitionDuration: "250ms",
      "--typeColor": theme.softGray,
      position: "relative",
      ":after": {
        content: "''",
        position: "absolute",
        height: 1,
        left: -1,
        right: -1,
        bottom: -1,
        backgroundColor: theme.softGray,
        transition: "transform 250ms, background-color 250ms",
        transformOrigin: "top",
      },
      ":hover": {
        transform: "translateY(-3px)",
        backgroundColor: theme.lightBlue30,
        borderColor: theme.midBlue,
        color: theme.midBlue,
        "--typeColor": theme.midBlue,
        ":after": {
          backgroundColor: theme.midBlue,
          transform: "scaleY(6)",
        },
      },
      [theme.tablet]: { padding: 14 },
      [theme.mobile]: { padding: 12 },
    }}
  >
    <h4 css={theme.bodyCopySm}>{title}</h4>
    <div
      css={{
        ...theme.t5md,
        color: "var(--typeColor)",
        marginLeft: 45,
        flexShrink: 0,
        [theme.tablet]: {
          marginLeft: 12,
          alignSelf: "flex-start",
          lineHeight: 1.5,
        },
      }}
    >
      {type}
    </div>
  </Link>
)

ListItem.propTypes = {
  title: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  type: PropTypes.oneOf(LINK_LIST_TYPES).isRequired,
}

LinkList.propTypes = {
  className: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      linkType: PropTypes.oneOf(LINK_LIST_TYPES).isRequired,
    })
  ),
}
